import { render, staticRenderFns } from "./AppleLoginButton.vue?vue&type=template&id=827b5dce&scoped=true"
import script from "./AppleLoginButton.vue?vue&type=script&lang=js"
export * from "./AppleLoginButton.vue?vue&type=script&lang=js"
import style0 from "./AppleLoginButton.vue?vue&type=style&index=0&id=827b5dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827b5dce",
  null
  
)

export default component.exports